import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9cb467"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Beranda", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Produk", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Etalase", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tanya Kami", -1))

import router from '@/router';
import { Icon } from '@iconify/vue';
import { computed, ref, watch } from 'vue';
import { chatWhatsApp } from '@/services/products.service';

export default /*#__PURE__*/_defineComponent({
  __name: 'BottomMenuBar',
  setup(__props) {

const path = computed(
  () => router.currentRoute.value.path ?? location.pathname,
);

const query = computed(() => router.currentRoute.value.query);

const pathToShow = ['/home', '/products', '/etalase'];
const show = computed(
  () => pathToShow.includes(path.value) && !query.value.category,
);

const menuBar = ref<HTMLDivElement>();
const height = computed(() => menuBar.value?.clientHeight);

watch([height, menuBar], () => {
  document.body.style.setProperty('--menu-height', height.value + 'px');
});

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "bottom-menu",
        ref_key: "menuBar",
        ref: menuBar
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["bottom-menu__menu-item", { active: path.value === '/home' }]),
          onClick: _cache[0] || (_cache[0] = 
        () => {
          path.value = '/home';
          _ctx.$router.replace({ name: 'home' });
        }
      )
        }, [
          _createVNode(_unref(Icon), { icon: "iconoir:small-shop-alt" }),
          _hoisted_1
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["bottom-menu__menu-item", { active: path.value === '/products' }]),
          onClick: _cache[1] || (_cache[1] = 
        () => {
          path.value = '/products';
          _ctx.$router.replace({ name: 'products' });
        }
      )
        }, [
          _createVNode(_unref(Icon), { icon: "carbon:drink-02" }),
          _hoisted_2
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["bottom-menu__menu-item", { active: path.value === '/etalase' }]),
          onClick: _cache[2] || (_cache[2] = 
        () => {
          path.value = '/etalase';
          _ctx.$router.replace({ name: 'etalase' });
        }
      )
        }, [
          _createVNode(_unref(Icon), { icon: "bx:cabinet" }),
          _hoisted_3
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["bottom-menu__menu-item", { active: path.value === '/call-center' }]),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(chatWhatsApp) && _unref(chatWhatsApp)(...args)))
        }, [
          _createVNode(_unref(Icon), { icon: "ic:baseline-whatsapp" }),
          _hoisted_4
        ], 2)
      ], 512))
    : _createCommentVNode("", true)
}
}

})